require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/number/is-nan.js
// module id = 72
// module chunks = 0 1